import { createStoreModulePath } from "@/lib/store.utils";
import { GetterTree } from "vuex";
import { ErrorsState } from "./types";
import { RootState } from "@/types";

export const rootErrorsGetterBuilder = createStoreModulePath('errors');

export const getterTypes = {
  showError: 'showError',
} as const;

export const getters: GetterTree<ErrorsState, RootState> = {
  [getterTypes.showError](state) {
    return state.errors?.length > 0;
  },
};
